import consumer from "./consumer"
import {formatTime} from "../utils/formatTime";

function findContainers() {
    return {
        unreadList: document.getElementById('unread-conversations'),
        readList: document.getElementById('read-conversations')
    };
}

consumer.subscriptions.create("UnreadMessageChannel", {
    connected() {
    },

    async received(data) {
        const navBarBadges = document.querySelectorAll(`[id='navbar-conversation-message-count-badge']`);

        const totalUnreadCount = data.total_unread_count || 0;
        navBarBadges.forEach(navBarBadge => {
            if (navBarBadge) {
                navBarBadge.textContent = totalUnreadCount > 0 ? String(totalUnreadCount) : "";
                navBarBadge.style.display = totalUnreadCount > 0 ? 'block' : 'none';
            }
        });

        let preview = document.getElementById(`conversation-preview-${data.channel_url}`)
        if (!preview) {
            await $.ajax({
                type: "GET",
                url: '/conversations',
                async: true,
                success: function (response) {
                    preview = document.getElementById(`conversation-preview-${data.channel_url}`)
                }
            });
        }

        const badge = document.getElementById(`unread-message-badge-${data.channel_url}`);
        const unreadChannelCount = data.channel_unread_count || 0;
        if (badge) {
            badge.textContent = unreadChannelCount > 0 ? String(unreadChannelCount) : "";
            badge.style.display = unreadChannelCount > 0 ? 'block' : 'none';
        }

        const conversationType = data.conversation_type || 'deal';
        if (conversationType === 'deal' && data.deal_uuid) {
            const dealUnreadCount = data.deal_unread_count || 0;
            const dealFilterUnreadBadge = document.getElementById(`unread-message-badge-${data.deal_uuid}`);
            if (dealFilterUnreadBadge) {
                dealFilterUnreadBadge.textContent = dealUnreadCount > 0 ? String(dealUnreadCount) : "";
                dealFilterUnreadBadge.style.display = dealUnreadCount > 0 ? 'block' : 'none';
            }
        }

        if (data.last_message_sent_at) {
            const lastMessageUpdate = document.getElementById(`last-update-${data.channel_url}`);
            if (lastMessageUpdate) {
                lastMessageUpdate.innerText = `${formatTime(data.last_message_sent_at)}`;
            }
        }

        if (data.message_text) {
            const lastMessage = document.getElementById(`last-message-${data.channel_url}`);
            if (lastMessage) {
                lastMessage.innerText = data.message_text;
            }
        }

        const {unreadList, readList} = findContainers();
        if (preview) {
            const isUnread = unreadChannelCount > 0;

            preview.dataset.moving = "true";
            preview.setAttribute('aria-busy', 'true');

            if (isUnread && unreadList) {
                if (readList && readList.contains(preview)) {
                    preview.remove();
                }
                unreadList.prepend(preview);
            } else if (!isUnread && readList) {
                if (unreadList && unreadList.contains(preview)) {
                    preview.remove();
                }

                readList.prepend(preview);
            }

            Promise.resolve().then(() => {
                delete preview.dataset.moving;
                preview.removeAttribute('aria-busy');
            });
        }
    }
});
